import { render, staticRenderFns } from "./MandatoryCompletionModal.vue?vue&type=template&id=1b6fc196&scoped=true"
import script from "./MandatoryCompletionModal.vue?vue&type=script&lang=js"
export * from "./MandatoryCompletionModal.vue?vue&type=script&lang=js"
import style0 from "./MandatoryCompletionModal.vue?vue&type=style&index=0&id=1b6fc196&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b6fc196",
  null
  
)

export default component.exports